export default __webpack_public_path__ + "images/Y2.ac1d492.png";